import React from 'react'
import { Button } from 'react-bootstrap'
import styles from '../CustomDomainModal.module.css'

export const ProgressIndicator = ({ steps, activeIndex }) => {
  return (
    <div className={styles.steps}>
      {Array.from({ length: steps }, (_, index) => (
        <div
          className={`${styles.step} ${activeIndex === index && styles.activeStep} ${
            activeIndex > index && styles.completeStep
          }`}
          key={index}
        />
      ))}
    </div>
  )
}

export const OptionButton = ({ active, actionlabel, actionDesc, selectOption }) => {
  return (
    <Button
      className={`${styles.optionButton} ${active && styles.activeOption}`}
      onClick={selectOption}
      variant="outline-primary p-4"
    >
      <div className={styles.optionButtonContent}>
        <span className={styles.option}>{actionlabel}</span>
        <span className={styles.optionSubText}>{actionDesc}</span>
      </div>
    </Button>
  )
}
